export default __webpack_public_path__ + "static/media/CRM-CAMPAIGN.65f62d0d.png";